// extracted by mini-css-extract-plugin
module.exports = {"RoundCards":"Dashboard_RoundCards__3koC8"};